import React from 'react'
import { Can } from '@morningtrain/react-auth'
import MenuItem from 'widgets/navigation/MenuItem'
import MenuItems from 'widgets/navigation/MenuItems'
import { Translation } from '@morningtrain/react-translations'
import * as Icons from 'ui/icons'
import Permissions from 'services/Permissions'
import MenuItemWrapper from 'widgets/navigation/MenuItemWrapper'
import EconomyMenuItems from 'widgets/navigation/partials/EconomyMenuItems'
import {Env} from "@morningtrain/helpers";

export default function AdminMainNavigationInner () {
  const stocktakeEnabled = Env.get('stocktake_enabled', false);
  console.log(Env.get());
  return (
    <MenuItemWrapper>
      <MenuItem
        route='app.dashboard.dashboard' label={<Translation name='dashboard.title' />}
        svgIcon={<Icons.Dashboard />} hasStatusBar
      />

      <MenuItems label={<Translation name='shifts.menu_title' />} svgIcon={<Icons.Shifts />}>
        <MenuItem route='app.shifts.planner' label={<Translation name='shifts.planner.title' />} hasStatusBar />
        <MenuItem route='app.shift_exchange.overview' label={<Translation name='shiftexchange.title' />} />
        <MenuItem route='app.shifts.entries_manage' label={<Translation name='historicshifts.manage_menu_title' />} />
        <MenuItem route='app.vacation.my_requests' label={<Translation name='vacation.my_requests.title'/>}/>`
      </MenuItems>

      <MenuItems label='Operations' svgIcon={<Icons.Operations />}>
        <MenuItem route='app.checklists' label={<Translation name='checklists.title' />} />
        <MenuItem route='app.cleaning.summary' label={<Translation name='cleaning.titles.menu' />} />
        <MenuItem route='app.onboarding.overview' label={<Translation name='onboarding.titles.overview' />} />
        <MenuItem route='app.hr.messages' label={<Translation name='hr.messages.title' />} />
        <MenuItem route='app.special_days.calendar' label={<Translation name='special_days.title' />} />
      </MenuItems>

      <Can permission={Permissions.INVENTORY_ORDER_ADMIN}>
        <MenuItems label={<Translation name='inventory.title' />} svgIcon={<Icons.Stock />}>
          <MenuItem route='app.inventory.order.overview' label={<Translation name='inventory.overview.title' />} />
          <MenuItem route='app.inventory.order.delivery' label={<Translation name='inventory.delivery.title' />} />
          <MenuItem route='app.inventory.norms.manage' label={<Translation name='inventory.norms.menu_title' />} />
          {stocktakeEnabled ? (
              <MenuItem route='app.inventory.stocktake.iframe' label={<Translation name='stock.count.title' />} />
            ) : null
          }
          <MenuItem route='app.inventory.item.index' label={<Translation name='inventory.item.index_title' />} />
          <MenuItem route='app.inventory.supplier.index' label={<Translation name='inventory.suppliers.title' />} />
          <MenuItem route='app.departments.index' />
        </MenuItems>
      </Can>

      <MenuItems svgIcon={<Icons.Users />} label={<Translation name='hr.title' />}>
        <MenuItem route='app.users.index' label={<Translation name='hr.users.title' />} />
        <MenuItem route='app.hr.email_templates' label={<Translation name='hr.email_templates.title' />} />
        <MenuItem route='app.hr.salary.overview' label={<Translation name='hr.salary.overview.title' />} />
        <MenuItem route='app.vacation_requests' label={<Translation name='hr.vacation.title' />} />
        <MenuItem route='app.settings.badges' label={<Translation name='settings.badges.titles.index' />} />
        {/* <MenuItem route='app.hr.seniority' label={<Translation name='hr.seniority.title' />} /> */}
        <MenuItem route='app.hr.employments' label={<Translation name='hr.employments.title' />} />
        <MenuItem route='app.hr.amo' label={<Translation name='hr.amo.title' />} />
        <MenuItem route='app.contracts.mine' label={<Translation name='hr.contracts.titles.my_contracts'/>}/>
      </MenuItems>

      <EconomyMenuItems />

      <MenuItems label={<Translation name='files.title' />} svgIcon={<Icons.Folder />}>
        <MenuItem
          route='app.files.employee_files.manage'
          label={<Translation name='files.employee_files.titles.manage' />}
        />
        <MenuItem
          route='app.files.employee_files.view'
          label={<Translation name='files.employee_files.titles.view' />}
        />
      </MenuItems>

      <MenuItems label={<Translation name='settings.title' />} svgIcon={<Icons.Settings />}>
        <MenuItem
          route='app.settings.departments.index'
          label={<Translation name='settings.departments.index.title' />}
        />
        <MenuItem
          route='app.settings.department_suppliers.index'
          label={<Translation name='settings.department_suppliers.titles.index' />}
        />
        <MenuItem
          route='app.settings.employment_types.index'
          label={<Translation name='settings.employment_types.titles.index' />}
        />
        <MenuItem route='app.settings.permissions' label={<Translation name='settings.permissions.title' />} />
        <MenuItem
          route='app.email_templates.index'
          label={<Translation name='email_templates.titles.index' />}
        />
        <MenuItem
          route='app.settings.inventory.index'
          label={<Translation name='inventory.title' />}
        />
      </MenuItems>
    </MenuItemWrapper>
  )
}
